import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class TradierLoginStore {
  root;
  loggedIn = true;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.loggedInSubject = groupByFunction(
      'messageType',
      'userLoggedIn',
      this.root.websocketSubject
    ).subscribe(() => {
      this.handleLoggedIn();
    });

    this.noAccountsStoredSubject = groupByFunction(
      'messageType',
      'noAccountsStored',
      this.root.websocketSubject
    ).subscribe(() => {
      this.handleNoAccountStored();
    });
  };

  handleLoggedIn = () => {
    this.loggedIn = true;
  };
  handleNoAccountStored = () => {
    this.loggedIn = false;
  };
}
